import React, { Component } from 'react'
// import Movie from './Movie'

import styled from 'styled-components'

const MovieBackground = styled.div`
  position: relative;
  background: url(${props => props.backdrop}) no-repeat;
  background-size: cover;
  height:60vh;
  margin-top:-130px;
  z-index:-10;
`;
const MovieInfo = styled.article`
   padding-top:430px;
   display:flex;
    flex-direction:row;
     > div {
       display: block;
       margin-left:40px;
       margin-top:80px;
     }
  }
`;

const POSTER_PATH = 'http://image.tmdb.org/t/p/w154'
const BACKDROP_PATH = 'http://image.tmdb.org/t/p/original'

export default class MovieSingle extends Component{

  state = {
    movie: []
  }
  async componentDidMount() {
    try{
      const res = await fetch(`https://api.themoviedb.org/3/movie/${this.props.match.params.id}?api_key=168a55cfe2647c9a3c7d87da50877434&language=en-US`)
      const movie = await res.json()
      this.setState({
        movie,
      })
    }catch(e){
      console.log(e)
    }
  }

  render(){
    const { movie } = this.state
    return(
        <MovieBackground backdrop={`${BACKDROP_PATH}${movie.backdrop_path}`}>
          <div className="container">
            <MovieInfo>
              <img src={`${POSTER_PATH}${movie.poster_path}`} alt={movie.title}
              title={movie.title}/>
                <div>
                  <h3>{movie.title}</h3>
                  <h5>{movie.release_date}</h5>
                  <p>{movie.overview}</p>
                </div>
            </MovieInfo>
          </div>
        </MovieBackground>
      )
  }
} 



// WEBPACK FOOTER //
// ./src/components/Movies/MovieSingle.js